const CONFIG = {
  dev: {
    apiURL: 'http://vn.elsaspeak.local',
    serverAPI: 'http://localhost:8000/api',
    affiliatePublicKey: '9aaa2446dc499074fc7a90c2f8309605',
    affiliateToken: 'd92cbcd4f1ea19db507fd956dfa2e47c',
    captchaSiteKey: '6LerZhsiAAAAAMjF79HlfVerlMMN73pbeIKFQdTE'
  },
  staging: {
    apiURL: 'https://vn-stag.elsaspeak.com',
    serverAPI: 'https://backend-vn-website.elsanow.io/api',
    affiliatePublicKey: '3dbcfb7a9d0f36e89d243b7c154f0b51',
    affiliateToken: '5121777470ca693be28ef4876325d423',
    captchaSiteKey: '6LerZhsiAAAAAMjF79HlfVerlMMN73pbeIKFQdTE'
  },
  production: {
    apiURL: 'https://vn.elsaspeak.com',
    serverAPI: 'https://backend-vn-website.elsanow.io/api',
    affiliatePublicKey: '935fb2dc41be01bc2c78ec9bd30e2da8',
    affiliateToken: 'f15cea0339fff8f1d0d451cb409e3698',
    captchaSiteKey: '6LerZhsiAAAAAMjF79HlfVerlMMN73pbeIKFQdTE'
  }
};

export default function env() {
  const currentStage = process.env.REACT_APP_ENV || 'dev';

  switch (currentStage) {
    case 'production':
      return CONFIG.production;
    case 'staging':
      return CONFIG.staging;
    default:
      return CONFIG.dev;
  }
}
